"use client";
import { Icon } from "@/components";
import { LoginButton } from "@/components/header/user-menu/login-button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import Image from "next/image";
import { useEffect, useState } from "react";
import { OnboardingForm } from "./onboarding-form";
import { useOnboardingController } from "./use-onboarding-controller";

export function OnboardingModal() {
  const { isModalOpen, setIsModalOpen } = useOnboardingController();
  const [href, setHref] = useState("");

  useEffect(() => {
    setHref(`${process.env.NEXT_PUBLIC_LOGIN_URL}${window.location.href}`);
  }, [setHref]);


  return (
    <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
      <DialogContent className="gap-0 p-0 border-0 w-full max-w-2xl!">
        <DialogHeader className="flex flex-row justify-between items-center bg-primary p-4 rounded-t-lg w-full">
          <DialogTitle className="text-muted">Cadastro</DialogTitle>
          <DialogClose onClick={() => setIsModalOpen((prev) => !prev)}>
            <Icon
              icon="MdClose"
              size={20}
              className="fill-muted cursor-pointer"
            />
          </DialogClose>
        </DialogHeader>

        <div className="items-center grid lg:grid-cols-2 bg-card-header p-4 rounded-b-lg">
          <div className="flex flex-col justify-between items-start gap-2">
            <div className="flex flex-col items-start space-y-4 mb-4">
              <h1 className="mb-0 font-bold text-secondary text-2xl">
                Olá, cidadão!
              </h1>
              <span className="text-xl">
                Você pode votar acessando com sua conta
              </span>
              <LoginButton
                className="bg-secondary hover:bg-secondary-foreground text-muted"
                href={href}
              />
            </div>
            <div className="flex flex-col w-full">
              <span className="mb-0 text-lg">
                ou usando seu e-mail pessoal.
              </span>
              <OnboardingForm />
            </div>
          </div>
          <Image
            src="/onboarding.svg"
            alt="Onboaring"
            width={1000}
            height={1000}
            priority
            className="hidden lg:block select-none"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
